import React, { useState } from 'react';
import CustomNavbar from '../../navbar/CustomNavbar';
import backgroundImage2 from '../../assets/finaltheme.png';
import { useNavigate } from 'react-router-dom';

// Add your own image paths below, you can use import, 'require', or direct links:
const carouselImages = [
  '/peaceandhoney/peace and honey.png',
  '/peaceandhoney/peace and honey.2.png',                          // Substitute with your other images
  '/peaceandhoney/peace and honey.3.png',
  '/peaceandhoney/peace and honey.4.png',
];

const config = {
  title: 'king kong in colaba, 2025',
  author: 'Joseph Vithayathil',
  medium:
    "Peace and Honey reflects a world suspended between faith and confusion where sacred architecture, human silhouette, and fragments of Arabic text intertwine. The artwork embodies a young man’s longing for harmony amidst the dissonance of politics and war, human estrangement, evoking the biblical vision of a “land of milk and honey” a place of sweetness, hope, and peace.",
  painting:"Digital Art",
  dimensions: '17.2cm x 17.2cm | 30x30 IN',
  details: ['Unique work'],
  price: '.$$$$$',
};

const PeaceAndHoney = () => {
  const [isImageMaximized, setIsImageMaximized] = useState(false);
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();

  const goLeft = () =>
    setCurrent((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);
  const goRight = () => setCurrent((prev) => (prev + 1) % carouselImages.length);

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundImage: `url(${backgroundImage2})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        fontFamily: "'Montserrat', sans-serif",
      }}
    >
      {/* Maximized Modal */}
      {isImageMaximized && (
        <div
          onClick={() => setIsImageMaximized(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.95)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            cursor: 'pointer',
          }}
        >
          <img
            src={carouselImages[current]}
            alt="Maximized Artwork"
            style={{
              maxWidth: '90vw',
              maxHeight: '90vh',
              objectFit: 'contain',
              boxShadow: '0 0 50px rgba(255,255,255,0.3)',
            }}
            onClick={(e) => e.stopPropagation()}
          />
          <button
            onClick={() => setIsImageMaximized(false)}
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'white',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              fontSize: '24px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
            }}
          >
            ×
          </button>
        </div>
      )}

      {/* Navbar */}
      <div style={{ position: 'fixed', top: 0, width: '100%', zIndex: 1000 }}>
        <CustomNavbar />
      </div>

      {/* Layout */}
      <div
        style={{
          display: 'flex',
          gap: '40px',
          maxWidth: '1400px',
          width: '100%',
          alignItems: 'flex-start',
          padding: '60px 20px 40px 20px',
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}
      >
        {/* Carousel Left Side */}
        <div
          style={{
            flex: '1',
            maxWidth: '50%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              position: 'relative',
              border: '70px solid #d9d9d9',
              background: '#222',
              borderRadius: '0px',
              width: '700px',
              height: '650px',
              boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <button
              style={{
                position: 'absolute',
                left: '-60px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: '10',
                background: 'transparent',
                border: 'none',
                borderRadius: '50%',
                width: '48px',
                height: '48px',
                fontSize: '30px',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(0,0,0,0.0)',
              }}
              onClick={goLeft}
              aria-label="Previous"
            >
              ‹
            </button>

            <img
              src={carouselImages[current]}
              alt={`Artwork ${current + 1}`}
              onClick={() => setIsImageMaximized(true)}
              style={{
                width: '600px',
                height: '530px',
                objectFit: 'cover',
                cursor: 'pointer',
                borderRadius: '0px',
                transition: 'transform 0.3s ease',
                boxShadow: '0 0px 46px rgba(0,0,0,0.20)',
              }}
              onMouseEnter={e => (e.target.style.transform = 'scale(1.02)')}
              onMouseLeave={e => (e.target.style.transform = 'scale(1)')}
            />

            <button
              style={{
                position: 'absolute',
                right: '-60px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: '10',
                background: 'transparent',
                border: 'none',
                borderRadius: '50%',
                width: '48px',
                height: '48px',
                fontSize: '30px',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(0,0,0,0.0)',
              }}
              onClick={goRight}
              aria-label="Next"
            >
              ›
            </button>

            {/* Carousel dots: small and inside border, below image */}
            <div
              style={{
                position: 'absolute',
                bottom: '-35px',
                left: '50%',
                transform: 'translateX(-50%)',
                display: 'flex',
                gap: '8px',
                zIndex: '10',
                background: 'transparent',
                pointerEvents: 'auto',
              }}
            >
              {carouselImages.map((_, idx) => (
                <span
                  key={idx}
                  style={{
                    width: '18px',
                    height: '7px',
                    borderRadius: '0px',
                    background: idx === current ? '#222' : '#eee',
                    border: idx === current ? '2px solid #fff' : '1px solid #bbb',
                    cursor: 'pointer',
                    display: 'inline-block',
                    transition: 'background 0.2s,border 0.2s',
                  }}
                  onClick={() => setCurrent(idx)}
                  aria-label={`Go to image ${idx + 1}`}
                />
              ))}
            </div>
          </div>
          {/* Black line below carousel */}
          <div
            style={{
              width: '700px',
              height: '3px',
              backgroundColor: '#979292',
              marginTop: '60px',
            }}
          />
        </div>

        {/* Info Card Module */}
        <div
          style={{
            width: '600px',
            height: '400px',
            backgroundColor: '#d9d9d9',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            color: '#000',
            boxShadow: '0 10px 20px rgba(0,0,0,0.3)',
          }}
        >
          <div>
            <h3
              style={{
                margin: '0',
                fontWeight: '700',
                fontSize: '32px',
                letterSpacing: -3,
                lineHeight: '0',
              }}
            >
              {config.author}
            </h3>
            <p
              style={{
                margin: '5px 0 10px',
                fontStyle: 'italic',
                fontSize: '32px',
                letterSpacing: '-3px',
                lineHeight: '2.5',
              }}
            >
              {config.title}
            </p>
            <p style={{ margin: '0', fontSize: '19px', fontWeight: '400', letterSpacing: -2, lineHeight: '1.3' }}>{config.painting}</p>
            <p style={{ margin: '0', fontSize: '19px', fontWeight: '400', letterSpacing: -2, lineHeight: '1.3' }}>{config.medium}</p>
            <p style={{ margin: '2px 0', fontSize: '19px', fontWeight: '400', letterSpacing: -2 }}>{config.dimensions}</p>
            {config.details.map((detail, index) => (
              <p key={index} style={{ margin: '0', fontSize: '19px', fontWeight: '400', letterSpacing: -2 }}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{detail}
              </p>
            ))}
          </div>
          <div
            style={{
              borderTop: '2px solid #979292',
              paddingTop: '10px',
              fontSize: '16px',
            }}
          >
            Estimated Value : {config.price}
          </div>
          </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '35px' }}>
         <img
         src='/logo.png'
         alt="Logo"
         style={{ width: '50px' }}
         />
          </div>
        </div>
      </div>
    
  );
};

export default PeaceAndHoney;
